import TimelineFullImage from '../../../../timeline/TimelineFullImage/TimelineFullImage';

const Image = require('../../../../../assets/img/timeline/modal/2002-impact.jpg');

const ImpactContent = () => {
    return (
        <>
            <TimelineFullImage image={Image} />
            <h4>
                The first IMPACT Program Workshop
            </h4>
            <p>
                The first IMPACT Program Workshop was held in Newcastle, to provide consumers with the opportunity to learn more about breast cancer clinical trials research and how clinical trials are developed and conducted. The aim of the program is to provide participants with the knowledge and skills needed to be effective advocates for breast cancer clinical trials in the wider community.
            </p>
        </>
    );
}

export default ImpactContent;